import * as React from 'react';
export const IcWateringCan = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.29 12a1 1 0 00-1.12.41l-1.33 2-2.22-1 1.88-2.15a2 2 0 00-.09-2.73l-4-4A2 2 0 0011.93 4a2 2 0 00-1.43.68l-.56.63a4 4 0 10-5.22 6L3.5 12.68a2 2 0 00.09 2.73l4 4A2 2 0 009 20h.07a2 2 0 001.43-.68l2-2.32h4.93l1.71 2.55A1 1 0 0020 20a1 1 0 00.29 0 1 1 0 00.71-1v-6a1.001 1.001 0 00-.71-1zM5 8a2 2 0 013.62-1.17L6.06 9.75A2 2 0 015 8z'
      fill='currentColor'
    />
  </svg>
);
